const NextIcon = () => (
  <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.28158 18.5311C1.08366 18.5311 0.885742 18.4582 0.729492 18.3019C0.427409 17.9998 0.427409 17.4998 0.729492 17.1978L7.52116 10.4061C8.02116 9.90609 8.02116 9.09359 7.52116 8.59359L0.729492 1.80192C0.427409 1.49984 0.427409 0.999837 0.729492 0.697754C1.03158 0.395671 1.53157 0.395671 1.83366 0.697754L8.62533 7.48942C9.15658 8.02067 9.45866 8.73942 9.45866 9.49984C9.45866 10.2603 9.16699 10.979 8.62533 11.5103L1.83366 18.3019C1.67741 18.4478 1.47949 18.5311 1.28158 18.5311Z" fill="#292D32"/>
  </svg>

);

export default NextIcon;

